export const environment = {
    production: true,
    apiUrl: "https://findmirest-dev.azurewebsites.net/",
    notificationInterval: 1,
    reCAPTCHASiteKey: "6LcxqKkZAAAAAP1s5o8weEozSdwVBsFwStWVq6A7",
    serviceWorker:false,
  };
  

  /*https://localhost:7059
  /*https://localhost:5001/
  *https://findmirest-dev.azurewebsites.net/
  */